define("shared/models/unsplash-image", ["exports", "@glimmer/tracking"], function (_exports, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  // Formats the caption using a raw response from unsplash
  function formatCaption(image) {
    if (image.user) {
      const source = `Media Source: ${image.links.html}`;
      const credit = `Photo by ${image.user.name} on Unsplash`;
      return `${source}\n${credit}`;
    }

    return '';
  }

  let UnsplashImage = (_class = class UnsplashImage {
    constructor(args) {
      _defineProperty(this, "alt_description", void 0);

      _defineProperty(this, "blur_hash", void 0);

      _defineProperty(this, "color", void 0);

      _defineProperty(this, "created_at", void 0);

      _defineProperty(this, "current_user_collections", void 0);

      _defineProperty(this, "description", void 0);

      _defineProperty(this, "downloads", void 0);

      _defineProperty(this, "exif", void 0);

      _defineProperty(this, "height", void 0);

      _defineProperty(this, "id", void 0);

      _initializerDefineProperty(this, "isSelected", _descriptor, this);

      _defineProperty(this, "liked_by_user", void 0);

      _defineProperty(this, "likes", void 0);

      _defineProperty(this, "links", void 0);

      _defineProperty(this, "promoted_at", void 0);

      _initializerDefineProperty(this, "showModal", _descriptor2, this);

      _defineProperty(this, "slug", void 0);

      _defineProperty(this, "topic_submissions", void 0);

      _defineProperty(this, "type", 'img');

      _defineProperty(this, "updated_at", void 0);

      _defineProperty(this, "urls", void 0);

      _defineProperty(this, "user", void 0);

      _defineProperty(this, "views", void 0);

      _defineProperty(this, "width", void 0);

      this.alt_description = args?.alt_description;
      this.blur_hash = args?.blur_hash;
      this.color = args?.color;
      this.created_at = args?.created_at;
      this.current_user_collections = args?.current_user_collections;
      this.description = args?.description || args?.alt_description;
      this.downloads = args?.downloads;
      this.exif = args?.exif;
      this.height = args?.height;
      this.id = args?.id;
      this.liked_by_user = args?.liked_by_user;
      this.likes = args?.likes;
      this.links = args?.links;
      this.promoted_at = args?.promoted_at;
      this.slug = args?.slug;
      this.topic_submissions = args?.topic_submissions;
      this.updated_at = args?.updated_at;
      this.urls = args?.urls;
      this.user = args?.user;
      this.views = args?.views;
      this.width = args?.width;
    }

    get captionText() {
      return formatCaption(this);
    }

    get source() {
      return this.links.html;
    }

    get standardResUrl() {
      return this.urls.regular;
    }

    get url() {
      return this.urls.regular;
    }

    get username() {
      return this.user.username;
    }

    get userProfile() {
      return this.user.links.html;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isSelected", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class);
  _exports.default = UnsplashImage;
});